import { Component, OnInit, ElementRef } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

import { Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ComprobanteService } from '../DataAccess/comprobantes.service';
import { CComprobanteData } from '../Model/ccomprobante.model';


@Component({
  selector: 'app-consulta-comprobantes',
  templateUrl: './consulta-comprobantes.component.html',
  styleUrls: ['./consulta-comprobantes.component.css']
})
export class ConsultaComprobantesComponent implements OnInit {

  @Input () hotel: string;

  capcha64: SafeResourceUrl;
  pdf64: string;
  xml64: string;
  public showLoadingSpinner: boolean = false;
  public EnvioSuccess: boolean = false;
  public EnvioFailed: boolean = false;

  data!:FormGroup;

  constructor(private translate: TranslateService, private genCaptcha:ComprobanteService, private domSanitizer:DomSanitizer, private generarComprobante:ComprobanteService) {
    this.crearFormulario()
    this.procesarConsulta()
  }

  ngOnInit(): void {
  }

  setLanguage(lang: string){
    this.translate.use(lang);
  }

  crearFormulario() {
    this.data = new FormGroup({
      Ruc: new FormControl('', [ Validators.required ]),
      TipoComprobante: new FormControl('', [ Validators.required ]),
      SerieNumero: new FormControl('', [ Validators.required ]),
      FechaEmision: new FormControl(Date.now(), [ Validators.required ]),
      MontoTotal: new FormControl('', [ Validators.required ]),
      CodigoCaptcha: new FormControl('', [ Validators.required ])
    })
  }

  limpiarFormulario() {
    this.data.reset()
  }

  get RucNoValido() {
    return this.data.get('Ruc')?.invalid && (this.data.get('Ruc')?.touched || this.data.get('Ruc')?.dirty)
  }
  get TipoComprobanteNoValido() {
    return this.data.get('TipoComprobante')?.invalid && (this.data.get('TipoComprobante')?.touched || this.data.get('TipoComprobante')?.dirty)
  }
  get SerieNumeroNoValido() {
    return this.data.get('SerieNumero')?.invalid && (this.data.get('SerieNumero')?.touched || this.data.get('SerieNumero')?.dirty)
  }
  get FechaEmisionNoValido() {
    return this.data.get('FechaEmision')?.invalid && (this.data.get('FechaEmision')?.touched || this.data.get('FechaEmision')?.dirty)
  }
  get MontoTotalNoValido() {
    return this.data.get('MontoTotal')?.invalid && (this.data.get('MontoTotal')?.touched || this.data.get('MontoTotal')?.dirty)
  }
  get CodigoCaptchaNoValido() {
    return this.data.get('CodigoCaptcha')?.invalid && (this.data.get('CodigoCaptcha')?.touched || this.data.get('CodigoCaptcha')?.dirty)
  }

  procesarComprobantePDF() {
    let cuerpo = new CComprobanteData()

    cuerpo = this.data.value

    if (this.data.valid) {
      this.generarComprobante.consultarComprobante(cuerpo).subscribe(
        data => {
          console.log('datos enviados correctamente')
          this.EnvioSuccess = true
          this.limpiarFormulario()
          this.procesarConsulta()

          console.log("datosssssss: " ,data.base64ResultPdf)

          this.pdf64 = "data:application/pdf;base64, " + data.base64ResultPdf
          this.xml64 = "data:application/xml;base64, " + data.base64ResultXml
          const source = this.pdf64;
          const link = document.createElement("a");
          link.href = source;
          link.download = `comprobantePDF.pdf`
          link.click();

        }, error => {
          this.EnvioFailed = true;
          console.log(error)
        }, () => { }
      )
    } else {
      console.log('datos inválidos')
      Object.values(this.data.controls).forEach(control => {
        control.markAllAsTouched()
      })
    }
  }

  procesarComprobanteXML() {
    let cuerpo = new CComprobanteData()

    cuerpo = this.data.value

    if (this.data.valid) {
      this.generarComprobante.consultarComprobante(cuerpo).subscribe(
        data => {
          console.log('datos enviados correctamente')
          this.EnvioSuccess = true
          this.limpiarFormulario()
          this.procesarConsulta()

          console.log("datosssssss: " ,data.base64ResultPdf)

          this.pdf64 = "data:application/pdf;base64, " + data.base64ResultPdf
          this.xml64 = "data:application/xml;base64, " + data.base64ResultXml
          const source = this.xml64;
          const link = document.createElement("a");
          link.href = source;
          link.download = `comprobanteXML.xml`
          link.click();

        }, error => {
          this.EnvioFailed = true;
          console.log(error)
        }, () => { }
      )
    } else {
      console.log('datos inválidos')
      Object.values(this.data.controls).forEach(control => {
        control.markAllAsTouched()
      })
    }
  }

  procesarConsulta() {
    this.showLoadingSpinner = true;
    this.genCaptcha.obtenerCaptcha().subscribe(
    data => {
      this.capcha64 = this.domSanitizer.bypassSecurityTrustResourceUrl("data:image/bmd;base64, " + data);
      console.log(this.capcha64)
    },
    error => {
      console.log(error);
    }, () => {
      this.showLoadingSpinner = false;
    });
  }

  showErrorConexionMessage(error){
    console.log(error);
  }

  refreshCaptcha() {
    this.procesarConsulta()
  }

  cerrarMensaje() {
    setTimeout(() => {
    }, 1000);
    this.EnvioSuccess = false;
    this.EnvioFailed = false;
  }


  // download PDF

  downloadPdf(base64String, fileName) {
    const source = base64String;
    const link = document.createElement("a");
    link.href = source;
    link.download = `${fileName}.pdf`
    link.click();
  }





}
